<template>
    <div class="demo-access" v-if="access">
        <div class="title">
            <h4>{{$t('demo.3rd title')}}</h4>
        </div>
        <div class="access">{{$t('demo.login and password')}} {{access.userName}}/{{access.password}}</div>
        <div class="download">
            <div>
                <a class="button" :href="access.cashierDownloadUrl" target="_blank">
                    <i class="cashier"></i>
                    <span>{{$t('demo.download')}}</span>
                </a>
                <a
                    class="button button-grey"
                    :href="access.cashierDownloadUrl"
                    target="_blank"
                >{{$t('demo.manual')}}</a>
            </div>
            <div>
                <a class="button" :href="access.monitorDownloadUrl" target="_blank">
                    <i class="monitor"></i>
                    <span>{{$t('demo.download')}}</span>
                </a>
                <a
                    class="button button-grey"
                    :href="access.monitorDownloadUrl"
                    target="_blank"
                >{{$t('demo.manual')}}</a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "demo-access",
    props: {
        access: Object
    },

    computed: {},

    mounted() {},
    beforeDestroy() {},
    methods: {}
};
</script>
<style lang="scss" scoped>
.title {
    font-size: 2.5rem;
    text-align: center;
    text-transform: uppercase;
    margin-bottom: $spacer * 4;

     h4 {
        margin-top: 0;
        margin-bottom: $spacer;
    }

    .desc {
        font-size: 2rem;
    }
}

.access {
    font-size: 2rem;
    text-align: center;
    margin-bottom: $spacer * 4;
}

.download {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .button {
        margin: $spacer/2;

        i {
            position: relative;
            display: inline-block;
            width: 32px;
            height: 32px;
            background-image: url("/assets/news.png");

            &.cashier {
                background-position-x: -32px;
            }

            &.monitor {
                background-position-x: -64px;
            }
        }
    }
}

@media (max-width: ($mobile)-1) {

    .title {
        margin-bottom: 0;
    }
}
</style>
